import { useQuery } from '@tanstack/react-query';
import useFetchWithMsal from "../../useFetchWithMsal";
import { protectedResources } from "../../../authConfig";

/**
 * Hook for fetching group managers from MongoDB
 * Used for the clarification feature - fetches managers for a specific group
 */
export const useGroupManagers = (groupId) => {
    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });

    const fetchGroupManagers = async () => {
        if (!groupId) return [];
        
        try {
            const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/group-managers/${groupId}`;
            
            const response = await execute(
                "GET",
                url
            );

            const managers = response?.managers || [];
            return managers.map((manager) => ({
                id: manager.email,
                name: manager.name,
                email: manager.email
            }));
        } catch (error) {
            console.error('Error fetching group managers:', error);
            return [];
        }
    };

    const { data: groupManagers = [], isLoading, error, refetch } = useQuery({
        queryKey: ['groupManagers', groupId],
        queryFn: fetchGroupManagers,
        enabled: !!groupId, 
        staleTime: 30 * 1000, 
        refetchOnWindowFocus: true,
        refetchOnMount: 'always'
    });

    return {
        groupManagers,
        isLoading,
        error,
        refetch
    };
};

export default useGroupManagers;
